import { Box, Stack } from "@mui/joy";
import React, { useEffect, useRef, useState } from "react";
import { useRecoilState } from "recoil";
import { refundQnAListState } from "../../recoil/refundQnAtom";
import { useNavigate } from "react-router-dom";
import CustomTypography from "../../components/common/CustomTypography";
import { theme } from "../../styles/theme";
import { useMutation } from "@tanstack/react-query";
import TextareaRefund from "./TextareaRefund";
import { refundApi } from "../../api/refundApi";
import { BottomNextButton } from "../../components/common/BottomNextButton";

export default function Refund_Submit({
  pageSeq,
  questionId,
  contentTextList,
  placeholder,
}: {
  pageSeq: number;
  questionId: number;
  contentTextList: string[];
  placeholder: string;
}) {
  const [refundQnAList, setRefundQnAList] = useRecoilState(refundQnAListState);
  const navigate = useNavigate();
  const [text, setText] = useState(
    refundQnAList.find((qa) => qa.questionId === questionId)?.answer
  );

  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  const [isFocused, setIsFocused] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const isButtonDisabled = text === undefined || text === "";

  const { mutate: submit } = useMutation({
    mutationFn: (vars: {
      questionId: number;
      answerId: number;
      answer: string;
    }) =>
      refundApi.submitSurvey({
        questionId: vars.questionId,
        answerId: vars.answerId,
        answer: vars.answer,
      }),
    onSuccess: () => {
      setLoading(false);
      navigate(`/refund?seq=${pageSeq + 1}`);
    },
  });

  /* ➋ 페이지 로드 후 자동으로 텍스트에어리어에 포커스 */
  useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.focus();
    }
  }, []);

  const handleSubmit = (
    questionId: number,
    answerId: number,
    answer: string
  ) => {
    // 선택한 답변을 refundQnAState에 저장
    setRefundQnAList((prev) => {
      const idx = prev.findIndex((qa) => qa.questionId === questionId);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { questionId, answerId, answer };
        return next;
      }
      return [...prev, { questionId, answerId, answer }];
    });

    setLoading(true);
    submit({ questionId, answerId, answer });
  };

  const handleUpdateText = (text: string) => {
    setText(text);
  };

  return (
    <Stack spacing={5} sx={{ height: "100%" }}>
      <Stack spacing={2}>
        {contentTextList.map((content, index) => (
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{ color: theme.vars.palette.Content.Strong }}
          >
            {content}
          </CustomTypography>
        ))}
      </Stack>

      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={1}
        sx={{ width: "100%" }}
      >
        <Box
          sx={{
            width: "100%",
            height: "200px",
            backgroundColor: "transparent",
            borderRadius: "6px",
            display: "flex",
            alignItems: "start",
            justifyContent: "start",
            boxShadow: `inset 0 0 0 1.333px ${theme.vars.palette.Border.Weak}`,
          }}
        >
          <TextareaRefund
            initialValue={text}
            handleChange={(newValue: string) => handleUpdateText(newValue)}
            isFocused={isFocused}
            setIsFocused={setIsFocused}
            placeholder={placeholder}
          />
        </Box>
      </Stack>

      {/*<KeyboardAwareBottomButton*/}
      {/*  loading={loading}*/}
      {/*  disabled={isButtonDisabled}*/}
      {/*  onClick={() => handleSubmit(questionId, 1, text!!)}*/}
      {/*  text={"다음"}*/}
      {/*  highlightBackground={false}*/}
      {/*/>*/}
      <BottomNextButton
        loading={loading}
        disabled={isButtonDisabled}
        onClick={() => handleSubmit(questionId, 1, text!!)}
        text={"다음"}
      />
    </Stack>
  );
}
